<span #svgContainer>
    <svg class="{{classes}}" [attr.viewBox]="viewbox" [innerHTML]="sanitizedSvg"></svg>
</span>
<!--[if !IE]><!-->
<!--<svg [ngClass]="classes"><use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="'/css/svg/icons.svg#' + icon"></use></svg>-->
<!--<![endif]-->
<!--
    !!!!! TODO: [ngClass] does not work on svg tag in EI !!!!!
-->